export enum authError {
    NotAuthorizedException = 'NotAuthorizedException',
    UsernameExistsException = 'UsernameExistsException',
    CodeMismatchException = 'CodeMismatchException',
    ExpiredCodeException = 'ExpiredCodeException',
    LimitExceededException = 'LimitExceededException'
}
